// @ts-strict-ignore
import { useCallback } from 'react';
import { useLinkTo } from '../../../../hooks';
import { SEARCH_ROUTE } from '../../../../route-names';
import { tiles } from '../../homepage/SearchTileGrid/SearchGridTiles';

const tileSearchParams = tiles.reduce((t, tile) => {
  // eslint-disable-next-line no-param-reassign
  t[tile.text] = tile.searchParams;
  return t;
}, {});

const useSearchTiles = () => {
  const linkTo = useLinkTo();

  const handleTileClick = useCallback((name: string) => {
    linkTo(SEARCH_ROUTE, {
      ...tileSearchParams[name],
      source: 'inactive_profile_search_tiles',
    });
  }, [linkTo]);

  return { handleTileClick, tiles };
};

export default useSearchTiles;
